import styled from '@emotion/styled';
import { Box, Grid, Typography } from '@mui/material';

export const FondContairer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap', // Permet aux éléments de se répartir sur plusieurs lignes
  padding: '2rem',
  textAlign: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 'auto',
  background: '#FFFFFF',
  borderRadius: '20px',
  gap: '2%',
  border: '1px solid #FF6E7229',
});

export const CaseContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  width: '20%', // Peut être ajusté avec des media queries
  height: '100%',
  paddingLeft: '1%',
  overflow: 'hidden',
  gap: '20px',

  // Media queries pour la responsivité
  '@media (max-width: 1200px)': {
    width: '25%', // 4 éléments par ligne
  },
  '@media (max-width: 900px)': {
    width: '33.33%', // 3 éléments par ligne
  },
  '@media (max-width: 600px)': {
    width: '50%', // 2 éléments par ligne
  },
  '@media (max-width: 400px)': {
    width: '100%', // 1 élément par ligne
  },
});

export const CaseHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',

});
export const CaseTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '16px',
  width: '100%',
  textAlign: 'left',
});


export const LineCase = styled(Box)({
  width: '90%',
  height: '2px',
  borderRadius: '20px',
  background: '#FD8A8D',
});

export const CaseDescription = styled(Typography)({
  width: '100%',
  fontWeight: '400',
  color: '#636F81',
  fontSize: '16px',
  wordBreak: 'break-word',
  textAlign: 'left',

});

export const ContainerButton =styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '8%',
  width: '100%',
});